exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "picture{width:100%}picture img{width:100%}\n", ""]);
